import { LoadingService } from 'src/app/core/layout/services/loading.service';
import { TokenCodeService } from '@wlp/ui-bs-token';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TransferService } from '@wlp/ui-bs-cashout';
import { PaymentPixService } from '@wlp/ui-bs-pix';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import * as moment from 'moment/moment';
import { LayoutConfigModel } from 'src/app/core/layout/models/layout-config.model';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';
import { ModalAlertComponent } from '../modal-alert/modal-alert.component';

@Component({
  selector: 'ui-t-modal',
  templateUrl: './modal-transfer-pix.component.html',
  styleUrls: ['./modal-transfer-pix.component.scss'],
})
export class ModalTransferPixComponent implements OnInit {

  public backgroundHeader: string;
  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;

  public formResumeValue: FormGroup;
  public isCheckedToggleRepeatPix = false;
  public datePickerConfig: any;
  public initialDate: string;
  public dateSchedule: string;
  public scheduled = false;
  private newDate: Date = new Date();
  public repeatStartDate: string = moment(this.newDate).format('DD/MM/YYYY');
  private datesSchedule: any;

  private readonly OPERATION: string = '919';
  private readonly LIST_DATES: string = '1';

  public isLoaded = false;

  @Input() public dataTransaction;
  @Input() public stateManagerData: any;

  constructor(
    public modalController: ModalController,
    private layoutConfigService: LayoutConfigService,
    private translate: UiBsTranslateService,
    private router: Router,
    private transferService: TransferService,
    private paymentPixService: PaymentPixService,
    private tokenCodeService: TokenCodeService,
    private loadingService: LoadingService,
  ) {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);
    this.backgroundHeader = this.layoutConfigService.getConfig('wlTheme.header.background.image');
    this.initialDate = moment(this.newDate).format('DD/MM/YYYY');
    this.dateSchedule = new Date().toLocaleDateString('pt-BR');
  }

  public async ngOnInit() {
    this.formResumeValue = new FormGroup({
      amountRecurrency: new FormControl('', Validators.required),
    });

    const result = await this.setListAvailableDates(
      this.dataTransaction.uuidWhiteLabel,
      this.OPERATION,
      this.LIST_DATES,
    );

    this.datePickerConfig = result.datePickerConfig;
    this.datesSchedule = result.datesSchedule;

    const selected = this.setDataSelected(this.initialDate, this.initialDate, this.datesSchedule);
    this.dateSchedule = selected.dateSchedule;
    this.scheduled = selected.scheduled;

    this.isLoaded = true;
  }

  public toggleRepeatPix(event: CustomEvent): void {
    const checked = event.detail.checked ? event.detail.checked : false;
    this.isCheckedToggleRepeatPix = checked;
    this.dataTransaction.scheduledRecurrent = checked;
  }

  public clickedOnSelectUntilDate(dateSelected: string): void {
    this.repeatStartDate = this.formatDateValue(dateSelected);
  }

  public onSelectedDate(dateSelected: any): void {
    if (!this.isLoaded || !this.datesSchedule) { return; }

    const data = this.setDataSelected(dateSelected, this.initialDate, this.datesSchedule);
    this.dateSchedule = data.dateSchedule;
    this.scheduled = data.scheduled;

    this.dataTransaction.dateSchedule = this.dateSchedule;
    this.dataTransaction.scheduled = this.scheduled;
  }

  private async setListAvailableDates(
    uuidWhiteLabel: string,
    code: string,
    type: string,
  ): Promise<{
    datePickerConfig: any;
    datesSchedule: any;
  }> {
    const daysAvailable = await this.transferService.checkDayResource(uuidWhiteLabel, code, type).toPromise();
    const datePickerConfig = this.createDatePickerConfig(this.newDate, daysAvailable.dateEnd);
    return {
      datePickerConfig,
      datesSchedule: daysAvailable,
    };
  }

  public setDataSelected(
    dateSelected: any,
    inicialDate: string,
    datesSchedule: any,
  ): { dateSchedule: string; scheduled: boolean } {
    const isSame = dateSelected === inicialDate;
    const date = isSame ? datesSchedule.dateStart : dateSelected;

    return {
      dateSchedule: this.formatDateValue(date),
      scheduled: !isSame,
    };
  }

  private createDatePickerConfig(newDate: Date, dateEnd: string): any {
    return {
      editable: false,
      locale: this.langDefault !== 'zh' ? this.langDefault : 'zh-hk',
      format: 'DD/MM/YYYY',
      firstDayOfWeek: 'su',
      disableKeypress: true,
      min: moment(newDate).format('DD/MM/YYYY'),
      max: moment(dateEnd).format('DD/MM/YYYY'),
    };
  }

  public onRecurrenceChange(value: string): void {
    this.dataTransaction.recurrencyType = value;
  }

  public onRepeatChange(value: string): void {
    this.dataTransaction.repeatType = value;
  }

  private formatDateValue(dateString: string): string {
    const dateParts = dateString.replace(/-/g, '/').split('/');
    if (dateParts.length === 3) {
      return dateParts[0].length === 4
        ? `${dateParts[0]}-${dateParts[1].padStart(2, '0')}-${dateParts[2].padStart(2, '0')}`
        : `${dateParts[2]}-${dateParts[1].padStart(2, '0')}-${dateParts[0].padStart(2, '0')}`;
    }
    throw new Error('Formato de data inválido');
  }

  public checkRecurrency() {
    if (this.isCheckedToggleRepeatPix) {
      if (this.dataTransaction.repeatType === 'QUANTITY') {
        const amountRecurrencyControl = this.formResumeValue.get('amountRecurrency');
        if (amountRecurrencyControl) {
          this.dataTransaction.amountRecurrency = Number(amountRecurrencyControl.value);
          this.dataTransaction.dateScheduleLimit = '';
        }
      }

      if (this.dataTransaction.repeatType === 'DATE') {
        const dateScheduleLimitControl = this.repeatStartDate;
        if (dateScheduleLimitControl) {
          this.dataTransaction.dateScheduleLimit = dateScheduleLimitControl;
          this.dataTransaction.amountRecurrency = '';
        }
      }
    } else {
      this.dataTransaction.recurrencyType = '';
      this.dataTransaction.repeatType = '';
      this.dataTransaction.dateScheduleLimit = '';
      this.dataTransaction.amountRecurrency = '';
    }
  }

  private preparePayload(data: any): any {
    const today = moment().format('YYYY-MM-DD');

    const scheduled = data.scheduled ? data.scheduled : false;

    let dateSchedule = data.dateSchedule;
    if (!dateSchedule) {
      dateSchedule = today;
    } else {
      const parsedDate = moment(dateSchedule, ['DD/MM/YYYY', 'YYYY-MM-DD'], true);
      dateSchedule = parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD') : today;
    }

    const allowedFields = [
      'accountNumber',
      'accountType',
      'agencyPayer',
      'bankDestination',
      'branch',
      'codeAuthorization',
      'currentAccountPayer',
      'dateSchedule',
      'devolutionCode',
      'document',
      'endToEnd',
      'isCharged',
      'ispb',
      'key',
      'name',
      'namePayer',
      'operationCode',
      'operationValue',
      'originNameBank',
      'personType',
      'pixDescription',
      'primaryDescription',
      'scheduled',
      'transactionId',
      'transactionIdCredit',
      'uuidAccountPayment',
      'uuidWhiteLabel',
      'description',
    ];

    const recurrencyFields = [
      'recurrencyType',
      'repeatType',
      'dateScheduleLimit',
      'amountRecurrency',
    ];

    const payload: any = {};

    allowedFields.forEach((field) => {
      if (field === 'scheduled') {
        payload.scheduled = scheduled;
      } else if (field === 'dateSchedule') {
        payload.dateSchedule = dateSchedule;
      } else if (data[field] !== undefined) {
        payload[field] = data[field];
      }
    });

    if (data.scheduledRecurrent) {
      recurrencyFields.forEach((field) => {
        if (data[field] !== undefined && data[field] !== '') {
          payload[field] = data[field];
        }
      });
    }

    return payload;
  }

  public async confirm() {
    this.loadingService.show();
    try {
      await this.generateAuthorizationCode();
      await this.checkRecurrency();

      const payload = this.preparePayload(this.dataTransaction);

      const res: any = await new Promise((resolve, reject) => {
        this.paymentPixService.pixTransaction(payload).subscribe({
          next: resolve,
          error: reject,
        });
      });

      this.dismissModal();

      if (res.isExecuted) {
        this.statusTransaction('success', 'Pix realizado com sucesso');
      } else {
        this.statusTransaction('warning-circle', 'Pix não realizado', res.message);
      }

    } catch (error) {
      this.dismissModal();
      this.statusTransaction('warning-circle', 'Pix não realizado');
      console.error('Erro ao confirmar Pix:', error);
    }
  }

  public async statusTransaction(status: string, message: string, description?: string) {
    this.loadingService.hide();
    const modalSuccess = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status,
        message,
        description,
        confirmBtn: 'CASH_OUT.TRANSFER_ON_US.CLOSE',
        translate: true,
      },
      backdropDismiss: false,
    });
    modalSuccess.onDidDismiss().then(() => {
      this.router.navigate(['/app/dashboard'], { replaceUrl: true });
    });
    return await modalSuccess.present();
  }

  public async dismissModal() {
    await this.modalController.dismiss();
  }

  private async generateAuthorizationCode(): Promise<void> {
    const userProfile = this.stateManagerData.pageData.userProfile;
    const uuidWhiteLabel = userProfile.uuidWhiteLabel;
    const uuidAccount = userProfile.uuidAccount;
    const token = await this.tokenCodeService.getToken(uuidWhiteLabel, uuidAccount).toPromise();
    this.dataTransaction.codeAuthorization = token.code || '';
  }
}
